module.exports = __webpack_public_path__ + "img/error-dark.daeaf309.svg";